import { axios } from "../utils/axios";
import { isAxiosError } from "axios";
import { toast } from "react-toastify";
import { useGeneralAppStore } from "../store/generalAppStore";
import { toastOptions } from "../config/toast";
import { useActasStore } from "../store/actasStore";
import { useNotificadoresStore } from "../store/notificadoresStore";
import { useMotivosStore } from "../store/motivosStore";

const useMotivos = () => {
  const { setNotificadores, notificadores } = useNotificadoresStore();
  const { setMotivos, motivos } = useMotivosStore();
  const { handlerLoading, handlerModal } = useGeneralAppStore();
  const { actas, setActas, actasFilter, setActasFilter, setActaDetalle, actaDetalle } =
    useActasStore();

  //TREA TODO LOS NOTIFICADORES
  const getMotivos = async () => {
    handlerLoading({ loading: true, loadName: "motivos" });
    const response = await axios().get("/get_motivos");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setMotivos(data)
        // console.log(data)
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "motivos" });
  };

  //ASIGNA UN NOTIFICADOR A UN ACTA
//   const asignarNotificador = async (dataSend) => {
//     handlerLoading({ loading: true, loadName: "confirmarNotificador" });
//     const response = await axios().post("/asignar_notificador", dataSend);
//     if (!isAxiosError(response)) {
//       const { data, error } = response.data;
//       if (data && !error) {
//         const newActas = actas.filter((acta) => acta.id != actaDetalle.acta.id);
//         setActas(newActas);
//         const newActasFilter = actasFilter.filter((acta) => acta.id != actaDetalle.acta.id);
//         setActasFilter(newActasFilter);
//         const newActaDetalle = actaDetalle;
//         newActaDetalle.acta.estado_id = 8;
//         newActaDetalle.acta.estado = {
//           id: 8,
//           descripcion: "EN REPARTO",
//         };
//         const notificadorFind = notificadores.find(
//           (notificador) => notificador.usuarioID == data.user_id_asignado
//         );
//         if (notificadorFind) {
//           const persona = {
//             persona: notificadorFind,
//           };
//           newActaDetalle.acta.notificador = [persona];
//         }


//         setActaDetalle(newActaDetalle);
//         toast.success("Notificador asigando al acta", toastOptions);
//         handlerModal({ modal: false, modalName: "notificadores" });
//       }
//       if (!data && error) {
//         toast.error(error, toastOptions);
        
//       }
//     } else {
//       toast.error("Hubo un error en la consulta", toastOptions);
//     }
//     handlerLoading({ loading: false, loadName: "confirmarNotificador" });
//   };

  return { getMotivos };
};

export default useMotivos;
